<script>

  import SidePill from '/components/Widgets/SidePill'
  import SideCircle from '/components/Widgets/SideCircle'
  import SideCircleDouble from '/components/Widgets/SideCircleDouble'

  export let widgets
  
  const dataItems = widgets.map( w => {
      // gather information
      const bgImage = w?.backgroundImage?.[0]?.url
      const title = w.title
      const text = w.widgetText
      const entryType = w.typeHandle
      const contentType = w.widgetSubType
      const linkedContent = w?.linkedContent?.[0]
      const typeHandle = linkedContent?.typeHandle
      const link = linkedContent ? { slug: linkedContent.slug, section: typeHandle === "text" ? "single" : typeHandle === "collection" ? "almanac" : typeHandle + "s"} : null

      // decide on component

      //// linked content widgets ////

      if (entryType === "contentWidget") {

        // content pill

        if (contentType === "2021SidebarPillContent") {

          return     {
            component: SidePill,
            props: {
              link: link
            },
            content: text
          }

        }

        // content circle

        if (contentType === "2021SidebarCircleContent") {

          return     {
            component: SideCircle,
            props: {
              link: link
            },
            content: text
          }

        }



      }

    //// link widgets ////

    // link pill

    if (entryType === "linkWidget" && contentType === "2021SidebarSingleLinkPill") {

      const linkObj = w?.links?.[0]
      const linkText = linkObj?.linkTitle
      const url = linkObj?.linkUrl

      return     {
        component: SidePill,
        props: {
          link: url
        },
        content: linkText
      }
    }

    // split circle

  if (entryType === "linkWidget" && contentType === "2021SidebarSplitCircle") {

    const linkObj1 = w?.links?.[0]
    const linkText1 = linkObj1?.linkTitle
    const url1 = linkObj1?.linkUrl

    const linkObj2 = w?.links?.[1]
    const linkText2 = linkObj2?.linkTitle
    const url2 = linkObj2?.linkUrl

    return     {
      component: SideCircleDouble,
      props: {
        top: linkText1,
        top_link : url1,
        bottom: linkText2,
        bottom_link : url2,
      },
    }
  }
  
    
  return false

  }).filter(i => i !== false)
  
  /*  
  const items = [
    {
      component: SidePill,
      content: "Book Ticket"
    },
    {
      component: SideCircle,
      content: "Theme"
    },
    {
      component: SideCircleDouble,
      props: {
        top: "Künstlerhaus Bethanien",
        bottom: "Silent Green Kulturquartier"
      }
    }    
  ]
  */
  
</script>

{#each dataItems as item}
  <div class="item">
    <svelte:component this={item.component} {...item.props}>
      { item.content }
    </svelte:component>
  </div>
{/each}

<style>
  .item {
    margin-bottom: 20px;
  }
</style>